<div class="sticky top-20 z-40 border-b border-border-strong bg-surface/95 shadow-elevated backdrop-blur-xl animate-fade-in">
    <div class="mx-auto max-w-7xl px-4 py-4 sm:px-6 lg:px-8">
        <div class="grid grid-cols-1 gap-3 lg:grid-cols-[1fr_auto_auto_auto]">
            <div class="relative">
                <i class="fas fa-magnifying-glass absolute top-1/2 -translate-y-1/2 text-text-muted ltr:left-4 rtl:right-4"></i>
                <input
                    type="text"
                    [ngModel]="searchQuery"
                    (ngModelChange)="onSearchChange($event)"
                    [placeholder]="'experts.filters.searchPlaceholder' | translate"
                    class="form-input text-start ltr:pl-12 ltr:pr-4 rtl:pl-4 rtl:pr-12">
            </div>

            <select [(ngModel)]="expertType" (change)="onFilterChange()" class="form-select min-w-44 cursor-pointer">
                <option value="all">{{ 'experts.filters.allTypes' | translate }}</option>
                <option value="broker">{{ 'experts.filters.individualBrokers' | translate }}</option>
                <option value="broker_company">{{ 'experts.filters.brokerCompanies' | translate }}</option>
                <option value="developer">{{ 'experts.filters.developers' | translate }}</option>
            </select>

            <select [(ngModel)]="minRating" (change)="onFilterChange()" class="form-select min-w-40 cursor-pointer">
                <option value="0">{{ 'experts.filters.allRatings' | translate }}</option>
                <option value="4.5">4.5+ {{ 'experts.filters.stars' | translate }}</option>
                <option value="4.7">4.7+ {{ 'experts.filters.stars' | translate }}</option>
                <option value="4.9">4.9+ {{ 'experts.filters.stars' | translate }}</option>
            </select>

            <select [(ngModel)]="sortBy" (change)="onFilterChange()" class="form-select min-w-44 cursor-pointer">
                <option value="rating">{{ 'experts.filters.highestRated' | translate }}</option>
                <option value="reviews">{{ 'experts.filters.mostReviewed' | translate }}</option>
                <option value="deals">{{ 'experts.filters.mostDeals' | translate }}</option>
                <option value="newest">{{ 'experts.filters.newest' | translate }}</option>
            </select>
        </div>
    </div>
</div>
